import { LowerCasePipe } from '@angular/common';
import { Component, input } from '@angular/core';
// eslint-disable-next-line boundaries/external
import { RouterModule } from '@angular/router';
import { IsGrantedDirective } from '@app/directives/is-granted.directive';
import { INav } from '@app/types/navs';

@Component({
    selector: 'app-navigation',
    imports: [RouterModule, LowerCasePipe, IsGrantedDirective],
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent {
    navs = input.required<INav[]>();
}
